module.exports = __webpack_public_path__ + "static/media/physical-health.7534d121.jpg";